// Core
import { Component, ChangeDetectorRef, NgZone, OnDestroy } from "@angular/core";
import { AnimationEvent } from "@angular/animations";
import { DomSanitizer } from "@angular/platform-browser";
import { Observable, Subject } from "rxjs";
import { first } from "rxjs/operators";

// Config
import { Toastr } from "./toastr";
import { ToastrOptions } from "./toastr.options";
import { ToastrAnimations } from "./toastr.animations";

@Component({
  selector: "app-toastr",
  template: `<div #toastrContainer id="toastr-container" class="{{position}}">
  <div *ngFor="let toastr of toastrs" [@inOut]="toastr.config.animate || animate" (@inOut.done)="onAnimationEnd($event)" class="toastr toastr-{{toastr.type}}" 
  (click)="clicked(toastr)">
    <div class="toastr-close-button" *ngIf="toastr.config.showCloseButton" (click)="removeToastr(toastr)">&times;
    </div> 
    <div *ngIf="toastr.title" class="to-title {{toastr.config.titleClass || titleClass}}">{{toastr.title}}</div>
    <div [ngSwitch]="toastr.config.enableHTML">
      <span *ngSwitchCase="true" class="to-message {{toastr.config.messageClass || messageClass}}" [innerHTML]="sanitizer.bypassSecurityTrustHtml(toastr.message)"></span>
      <span *ngSwitchDefault class="to-message {{toastr.config.messageClass || messageClass}}">{{toastr.message}}</span>
    </div>             
  </div>
</div>`,
  styles: [`.to-title{font-weight:700;font-size:16px;margin-bottom:8px;color:#fff}.to-message{word-wrap:break-word;font-size:14px;line-height:20px;display:block;color:#fff;background-color:transparent}.to-message a,.to-message label{color:#fff}.to-message a:hover{color:#ccc;text-decoration:none}.toastr-close-button{position:relative;right:-5px;top:-15px;float:right;font-size:25px;color:#fff;-webkit-text-shadow:0 1px 0 #fff;text-shadow:0 1px 0 #fff;opacity:.8}.toastr-close-button:focus,.toastr-close-button:hover{color:#000;text-decoration:none;cursor:pointer;opacity:.4}button.toastr-close-button{padding:0;cursor:pointer;background:0 0;border:0;-webkit-appearance:none}.top-center{top:0;right:0;width:100%}.bottom-center{bottom:0;right:0;width:100%}.top-full-width{top:0;right:0;width:100%}.bottom-full-width{bottom:0;right:0;width:100%}.top-left{top:12px;left:12px}.top-right{top:12px;right:12px}.bottom-right{right:12px;bottom:12px}.bottom-left{bottom:12px;left:12px}#toastr-container{position:fixed;z-index:99999}#toastr-container *{box-sizing:border-box}#toastr-container>div{position:relative;overflow:hidden;margin:10px 0 6px;padding:15px 15px 15px 60px;width:345px;border-radius:3px;background-position:15px;background-repeat:no-repeat;box-shadow:0 0 12px #999;color:#fff;opacity:1}#toastr-container>div.toastr-custom{padding:15px;color:#030303}#toastr-container>div.toastr-custom .toastr-close-button{color:#999!important}#toastr-container>:hover{box-shadow:0 0 12px #000;opacity:1;cursor:pointer}#toastr-container>.toastr-info{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGwSURBVEhLtZa9SgNBEMc9sUxxRcoUKSzSWIhXpFMhhYWFhaBg4yPYiWCXZxBLERsLRS3EQkEfwCKdjWJAwSKCgoKCcudv4O5YLrt7EzgXhiU3/4+b2ckmwVjJSpKkQ6wAi4gwhT+z3wRBcEz0yjSseUTrcRyfsHsXmD0AmbHOC9Ii8VImnuXBPglHpQ5wwSVM7sNnTG7Za4JwDdCjxyAiH3nyA2mtaTJufiDZ5dCaqlItILh1NHatfN5skvjx9Z38m69CgzuXmZgVrPIGE763Jx9qKsRozWYw6xOHdER+nn2KkO+Bb+UV5CBN6WC6QtBgbRVozrahAbmm6HtUsgtPC19tFdxXZYBOfkbmFJ1VaHA1VAHjd0pp70oTZzvR+EVrx2Ygfdsq6eu55BHYR8hlcki+n+kERUFG8BrA0BwjeAv2M8WLQBtcy+SD6fNsmnB3AlBLrgTtVW1c2QN4bVWLATaIS60J2Du5y1TiJgjSBvFVZgTmwCU+dAZFoPxGEEs8nyHC9Bwe2GvEJv2WXZb0vjdyFT4Cxk3e/kIqlOGoVLwwPevpYHT+00T+hWwXDf4AJAOUqWcDhbwAAAAASUVORK5CYII=)!important}#toastr-container>.toastr-error{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAHOSURBVEhLrZa/SgNBEMZzh0WKCClSCKaIYOED+AAKeQQLG8HWztLCImBrYadgIdY+gIKNYkBFSwu7CAoqCgkkoGBI/E28PdbLZmeDLgzZzcx83/zZ2SSXC1j9fr+I1Hq93g2yxH4iwM1vkoBWAdxCmpzTxfkN2RcyZNaHFIkSo10+8kgxkXIURV5HGxTmFuc75B2RfQkpxHG8aAgaAFa0tAHqYFfQ7Iwe2yhODk8+J4C7yAoRTWI3w/4klGRgR4lO7Rpn9+gvMyWp+uxFh8+H+ARlgN1nJuJuQAYvNkEnwGFck18Er4q3egEc/oO+mhLdKgRyhdNFiacC0rlOCbhNVz4H9FnAYgDBvU3QIioZlJFLJtsoHYRDfiZoUyIxqCtRpVlANq0EU4dApjrtgezPFad5S19Wgjkc0hNVnuF4HjVA6C7QrSIbylB+oZe3aHgBsqlNqKYH48jXyJKMuAbiyVJ8KzaB3eRc0pg9VwQ4niFryI68qiOi3AbjwdsfnAtk0bCjTLJKr6mrD9g8iq/S/B81hguOMlQTnVyG40wAcjnmgsCNESDrjme7wfftP4P7SP4N3CJZdvzoNyGq2c/HWOXJGsvVg+RA/k2MC/wN6I2YA2Pt8GkAAAAASUVORK5CYII=)!important}#toastr-container>.toastr-success{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADsSURBVEhLY2AYBfQMgf///3P8+/evAIgvA/FsIF+BavYDDWMBGroaSMMBiE8VC7AZDrIFaMFnii3AZTjUgsUUWUDA8OdAH6iQbQEhw4HyGsPEcKBXBIC4ARhex4G4BsjmweU1soIFaGg/WtoFZRIZdEvIMhxkCCjXIVsATV6gFGACs4Rsw0EGgIIH3QJYJgHSARQZDrWAB+jawzgs+Q2UO49D7jnRSRGoEFRILcdmEMWGI0cm0JJ2QpYA1RDvcmzJEWhABhD/pqrL0S0CWuABKgnRki9lLseS7g2AlqwHWQSKH4oKLrILpRGhEQCw2LiRUIa4lwAAAABJRU5ErkJggg==)!important}#toastr-container>.toastr-warning{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGYSURBVEhL5ZSvTsNQFMbXZGICMYGYmJhAQIJAICYQPAACiSDB8AiICQQJT4CqQEwgJvYASAQCiZiYmJhAIBATCARJy+9rTsldd8sKu1M0+dLb057v6/lbq/2rK0mS/TRNj9cWNAKPYIJII7gIxCcQ51cvqID+GIEX8ASG4B1bK5gIZFeQfoJdEXOfgX4QAQg7kH2A65yQ87lyxb27sggkAzAuFhbbg1K2kgCkB1bVwyIR9m2L7PRPIhDUIXgGtyKw575yz3lTNs6X4JXnjV+LKM/m3MydnTbtOKIjtz6VhCBq4vSm3ncdrD2lk0VgUXSVKjVDJXJzijW1RQdsU7F77He8u68koNZTz8Oz5yGa6J3H3lZ0xYgXBK2QymlWWA+RWnYhskLBv2vmE+hBMCtbA7KX5drWyRT/2JsqZ2IvfB9Y4bWDNMFbJRFmC9E74SoS0CqulwjkC0+5bpcV1CZ8NMej4pjy0U+doDQsGyo1hzVJttIjhQ7GnBtRFN1UarUlH8F3xict+HY07rEzoUGPlWcjRFRr4/gChZgc3ZL2d8oAAAAASUVORK5CYII=)!important}#toastr-container.bottom-center>div,#toastr-container.top-center>div{width:300px;margin:10px auto}#toastr-container.bottom-full-width>div,#toastr-container.top-full-width>div{width:96%;margin:10px auto}.toastr{background-color:#fff}.toastr-success{background-color:#51a351}.toastr-error{background-color:#d9534f}.toastr-info{background-color:#7460ee}.toastr-warning{background-color:#f89406}.toastr-progress{position:absolute;left:0;bottom:0;height:4px;background-color:#000;opacity:.4}@media all and (max-width:240px){#toastr-container>div{padding:8px 8px 8px 50px;width:11em}#toastr-container .toastr-close-button{right:-.2em;top:-.2em}}@media all and (min-width:241px) and (max-width:480px){#toastr-container>div{padding:8px 8px 8px 50px;width:18em}#toastr-container .toastr-close-button{right:-.2em;top:-.2em}}@media all and (min-width:481px) and (max-width:768px){#toastr-container>div{padding:15px 15px 15px 50px;width:25em}}`],
  animations: [ToastrAnimations]
})
export class ToastrComponent implements OnDestroy {
  messageClass: string;
  titleClass: string;
  position: string;
  maxShown: number;
  newestOnTop: boolean;
  animate: string;
  toastrs: Toastr[] = [];

  private _fresh: boolean = true;
  public onToastClicked: (toast: Toastr) => void;

  private _onEnter: Subject<any> = new Subject();
  private _onExit: Subject<any> = new Subject();

  constructor(
    public sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
    private _zone: NgZone,
    options: ToastrOptions
  ) {
    Object.assign(this, options);
  }

  onEnter(): Observable<void> {
    return this._onEnter.asObservable();
  }

  onExit(): Observable<void> {
    return this._onExit.asObservable();
  }

  addToastr(toast: Toastr) {
    if (this.position.indexOf("top") > 0) {
      if (this.newestOnTop) {
        this.toastrs.unshift(toast);
      } else {
        this.toastrs.push(toast);
      }

      if (this.toastrs.length > this.maxShown) {
        const diff = this.toastrs.length - this.maxShown;

        if (this.newestOnTop) {
          this.toastrs.splice(this.maxShown);
        } else {
          this.toastrs.splice(0, diff);
        }
      }
    } else {
      this.toastrs.unshift(toast);
      if (this.toastrs.length > this.maxShown) {
        this.toastrs.splice(this.maxShown);
      }
    }    

    if (this.animate === null && this._fresh) {
      this._fresh = false;
      this._onEnter.next();
      this._onEnter.complete();
    }

    this.cdr.detectChanges();
  }

  removeToastr(toast: Toastr) {
    if (toast.timeoutId) {
      clearTimeout(toast.timeoutId);
      toast.timeoutId = null;
    }

    this.toastrs = this.toastrs.filter(t => {
      return t.id !== toast.id;
    });
  }

  removeAllToasts() {
    this.toastrs.forEach((toast: Toastr) => {
      clearTimeout(toast.timeoutId);
      toast.timeoutId = null;
    });
    
    this.toastrs = [];
  }

  clicked(toast: Toastr) {
    if (this.onToastClicked) {
      this.onToastClicked(toast);
    }
  }

  anyToast(): boolean {
    return this.toastrs.length > 0;
  }

  findToast(toastId: number): Toastr | void {
    for (let toast of this.toastrs) {
      if (toast.id === toastId) {
        return toast;
      }
    }
    return null;
  }

  onAnimationEnd(event: AnimationEvent) {
    if (event.toState === "void" && !this.anyToast()) {
      this._ngExit();
    } else if (this._fresh && event.fromState === "void") {
      // notify when first animation is done
      this._fresh = false;
      this._zone.run(() => {
        this._onEnter.next();
        this._onEnter.complete();
      });
    }
  }

  private _ngExit() {
    this._zone.onMicrotaskEmpty.subscribe(() => {
      this._onExit.next();
      this._onExit.complete();
    });
  }

  ngOnDestroy() {
    this._ngExit();
  }
}
